import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { RegisterNewUser } from '../../actions/user.js';
import RegisterForm from './registerform';
import TopNav from '../includes/TopNav';
class Step4Page extends Component{
  constructor(props) {
    super(props);
  }
  submit = (values) => {
    this.props.dispatch(RegisterNewUser(values, this.props.Paper));
    this.props.history.push('/');
  }
  render() {
    return (
      <div>
        <TopNav />
        <section className="thankyou">
          <div>
            <div className="banner-row">
              404: Page not found.
              <div className="small-banner">Please navigate back home :) </div>
            </div>
          </div>
        </section>
     </div>
    )
  }
}

export default connect(
  ({Paper, Modals, User})=>({Paper, Modals, User})
)(Step4Page);



// WEBPACK FOOTER //
// ./src/components/steps/NotFound.js